import http from '../http'

export default {
	getFiles: () => {
		return http.get('/grn_record')
	},
	getFilesWithPagination: (payload) => {
		return http.get('/grn_record?page=' + payload.page + '&size=' + payload.size + '&paginate=Y')
	},
	uploadFile: (formData) => {
		return http.post('/grn_record', formData)
	},
	approveFile: (record) => {
		return http.post('/grn_record/approve', record)
	},
	deleteFile: (record) => {
		return http.post('/grn_record/delete-grnFile', record)
	},
	rejectFile: (record) => {
		return http.post('/grn_record/reject', record)
	},
	viewFile: (fileId) => {
		return http.get(`/upload/catalogue/${fileId}/data`)
	},

	viewPendingCollection: () => {
		return http.get(`/warrant/pendingCollection`)
	},
	viewDeletedFile: (fileId) => {
		return http.get(`/grn_record/deleted/${fileId}`)
	},
	download: (fileId) => {
		return http.get(`/grn_record/download/${fileId}`, { responseType: 'blob' })
	},
	warehouseApproveRecords: (records) => {
		return http.post('/grn_record/approve_record', records)
	},

	brokerApproveRecords: (records) => {
		return http.post('/upload/catalogue/approve_records', records)
	},
	
	millerApproveRecord: (record) => {
		return http.post('/grn_record/confirm/approve', record)
	},
	editRecord: (record) => {
		return http.post('/upload/catalogue/edit', record)
	},
	getRecordsPendingApproval: () => {
		return http.get('/grn_record/records_pending_approval')
	},

	/*Sweepings*/

	viewSweepingsFile: (fileId) => {
		return http.get(`/upload/sweepings/${fileId}/data`)
	},
	sweepingsApproveRecords: (records) => {
		return http.post('/upload/sweepings/approve_records', records)
	},

	SpecialityRecords: (records) => {
		return http.post('/upload/speciality/catalogue/approve_records', records)
	}
}
